import { Alert } from '@/services/alert.service';
import { i18n } from '@/i18n';
import type { Booking } from '@/entities/bookings/booking.entity';
import { PaymentLinkReceiver } from '@carvia/ros-client-types';
import { UserRole } from '@/entities/auth/user-role.enum.ts';

export const selectPaymentLinkReceiver = async (
  booking: Booking,
  paymentLinkReceiver?: PaymentLinkReceiver,
) => {
  const t = i18n.global.t;
  const inputOptions: Record<string, string> = {};
  if (booking.customer && paymentLinkReceiver !== PaymentLinkReceiver.AGENCY) {
    inputOptions[PaymentLinkReceiver.CUSTOMER] = t('paymentLink.customer');
  }
  if (booking.agency && paymentLinkReceiver !== PaymentLinkReceiver.CUSTOMER) {
    inputOptions[PaymentLinkReceiver.AGENCY] =
      booking.agency.role === UserRole.COMPANY
        ? t('paymentLink.companyAccount')
        : t('paymentLink.agency');
  }
  inputOptions[PaymentLinkReceiver.NONE] = t('paymentLink.copyLink');
  const { value, isConfirmed } = await Alert.fire({
    text: t('paymentLink.selectReceiverText'),
    icon: 'question',
    showDenyButton: true,
    confirmButtonText: t('paymentLink.createPaymentLink'),
    denyButtonText: t('cancel'),
    input: 'select',
    inputOptions,
    inputValue: paymentLinkReceiver,
  });
  if (!isConfirmed) return;
  return value as PaymentLinkReceiver;
};

export const showPaymentLinkToCopy = async (paymentLink: string) => {
  const t = i18n.global.t;
  let couldNotCopy = false;
  try {
    await navigator.clipboard.writeText(paymentLink);
  } catch (error) {
    console.error('Failed to copy text: ', error);
    couldNotCopy = true;
  }
  await Alert.fire({
    html: couldNotCopy ? t('paymentLink.couldNotCopyText') : t('paymentLink.copyThisLinkText'),
    icon: 'success',
    confirmButtonText: t('close'),
    input: 'text',
    inputValue: paymentLink,
    inputAttributes: { readonly: 'readonly' },
    showInputCopyButton: true,
  });
};
